import axios from 'axios';
import config from './config';

const api = axios.create({
  baseURL: config.api.baseURL,
  timeout: config.api.timeout,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false, // Set to true if you use cookies for auth
});

// Attach token to every request if present
api.interceptors.request.use(
  (requestConfig) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      requestConfig.headers['Authorization'] = `Bearer ${token}`;
    }
    
    // Log API calls in development mode
    if (config.debug.logApiCalls) {
      console.log(`🚀 API Request: ${requestConfig.method?.toUpperCase()} ${requestConfig.url}`);
    }
    
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

// Global error handler (optional)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // You can handle global errors here (e.g., logout on 401)
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('adminToken');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export const apiGet = (url, config) => api.get(url, config);
export const apiPost = (url, data, config) => api.post(url, data, config);
export const apiPut = (url, data, config) => api.put(url, data, config);
export const apiPatch = (url, data, config) => api.patch(url, data, config);
export const apiDelete = (url, config) => api.delete(url, config);

export default api; 